import React, { useEffect, useState, useRef } from "react";

import {
  agmsClientRequestGet,
  agmsClientRequestPost
} from "../../apis/request";//"../../apis/request";

import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

// const SignUpComponent = ({logInUp, setLogInUp, termAgreement, setTermAgreement}) => {

const ResetPasswordDialog = ({onClose, selectedValue, open}) => {
//   const { onClose, selectedValue, open } = props;
    const [email, setEmail] = useState("");

    const handleClose = () => {
        //타이머 리셋
        resetTimer();
        setEmail('');
        setCertNumber('');
        setPassword('');
        setPasswordCheck('');
        setCertNumberSendCheck(false);
        setCertNumberCertifiedCheck(false);
        onClose(selectedValue);
    };

//   const handleListItemClick = (value) => {
//     onClose(value);
//   };


    // #region 이메일 인증 관련
    const [emailCodeId, setEmailCodeId] = useState(null);
    const [certNumber, setCertNumber] = useState('');
    const [password, setPassword] = useState('');
    const [passwordCheck, setPasswordCheck] = useState('');
    const [certNumberSendCheck, setCertNumberSendCheck] = useState(false);
    const [certNumberCertifiedCheck, setCertNumberCertifiedCheck]= useState(false);
    
    const onSendEmailCode = async (e) => {
        try{
            startTimer();
            setCertNumberSendCheck(true);
            
            let result = await agmsClientRequestGet(
                `/api/email/pwd/reset?email=${email}`
            );
            if(result !== null && result !== undefined){
                alert('이메일을 발송했습니다. 인증번호를 확인해주세요!');
               
            }
            setEmailCodeId(result.email_code_id);
           
        }
        catch(error){
            if(error.response?.status === 418){
                alert("변경 할 수 없습니다.");
                handleClose();
                return;
            }
        }
        
    };

    const onCheckCertNumber = async (e) => {
        let body = {
            email_code_id : emailCodeId,
            email_code : certNumber
        }
        
        let result = await agmsClientRequestPost(
            `/api/email/code/check`,
            body
        );

        let resultObject = {
            is_success: result.is_success,
            message: result.message
        }

        if (resultObject.is_success){
            setCertNumberCertifiedCheck(true);
            //alert('인증되었습니다.');
            resetTimer();
        } 
        else {
            alert('코드가 맞지 않습니다.');
        }
    };
        // #endregion
        
    // #region 인증번호 타이머 관련
    const INITIAL_SECONDS = 5 * 60;
    const timerRef = useRef(null);
    const [isRunning, setIsRunning] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(INITIAL_SECONDS); // 5분 = 300초

    const formatTime = (totalSeconds) => {
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    useEffect(() => {
        if(isRunning){
            timerRef.current = setInterval(() => {
            setSecondsLeft(prev => {
                if(prev <= 1){
                clearInterval(timerRef.current);
                setIsRunning(false);
                return 0;
                }
                return prev - 1;
            });
            }, 1000);
            return () => clearInterval(timerRef.current); // 클린업
        }
    },[isRunning]);

    useEffect(()=>{
        if(secondsLeft == 0){
            setCertNumberSendCheck(false);
            setEmail('');
            setCertNumber('');
        }
    },[secondsLeft]);

    const startTimer = () => {
        setSecondsLeft(INITIAL_SECONDS);
        setIsRunning(true);
    };

    const resetTimer = () => {
        clearInterval(timerRef.current);
        setIsRunning(false);
        setSecondsLeft(INITIAL_SECONDS);
    };
    // #endregion

    function validatePassword(password) {
        const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[:!@%$%^&*()+=._-])[A-Za-z\d:!@%$%^&*()+=._-]{8,16}$/;
        return regex.test(password);
    }
    const onResetPassword = async () => {
        //비밀번호가 체크와 같은 지 확인
        try{
            
            if(password !== passwordCheck){
                alert('비밀번호가 일치하지 않습니다!');
                return;
            }

            if(!validatePassword(password)){
                alert('비밀번호 조건이 맞지 않습니다.');
                return;
            }

       
            //api 콜
            let body = {
                email : email,
                password : password,
                device : 1104
            }
            let result = await agmsClientRequestPost('/api/user/update/password', body);
            if(result.is_success){
                alert('비밀번호 변경에 성공했습니다! 다시 로그인 해주세요.');
                handleClose();
            }

        }catch(err){

        }
    }

    return (
        <Dialog 
            onClose={handleClose} 
            open={open}
        >
            {
               certNumberCertifiedCheck ?
               <>
                <DialogTitle>
                    비밀번호 입력.
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        새로운 비밀번호를 입력해주세요.

                        <TextField 
                            fullWidth 
                            label="비밀번호" 
                            value={password || ''}
                            type="password"
                            onChange={(e) => setPassword(e.target.value)} style={{
                                marginTop:'10px' 
                            }}/>
                        <div style={{height:"25px", fontSize:'13px'}}>*10자 이상이면서 영문, 숫자, 특수문자를 모두 포함하세요.</div>
                        
                        <div style={{height:"25px"}}></div>
                        
                        <TextField 
                            fullWidth 
                            label="비밀번호 확인" 
                            value={passwordCheck || ''}
                            type="password"
                            onChange={(e) => setPasswordCheck(e.target.value)}/>
                        <div style={{height:"25px", fontSize:'13px'}}>*비밀번호를 다시 입력해주세요.</div>
                    </DialogContentText>
                    
                    <div style={{
                        display:'flex',
                        justifyContent:'center',
                        marginTop:'20px'
                    }}>
                        <Button fullWidth variant="contained" size="middle" onClick={() => onResetPassword()}>
                            재설정하기
                        </Button>
                    </div>

                    
                </DialogContent> 
               </> 
               : 
               <>
                <DialogTitle>
                    비밀번호를 잊으셨나요?
                </DialogTitle>
                
                <DialogContent>
                    <DialogContentText>
                        이메일 인증을 해주세요.
                        <TextField 
                            disabled={certNumberSendCheck} 
                            fullWidth 
                            type='email'
                            label="이메일" 
                            value={email || ''}
                            onChange={(e) => setEmail(e.target.value)} style={{
                                marginTop:'10px'
                            }}/>
                    
                        <div style={{height:"5px"}}></div>
                        
                        <div style={{
                            display:'flex',
                            justifyContent:'end',
                        }}>
                            {certNumberCertifiedCheck ? 
                                <>
                                    <DoneIcon color="success"/>
                                </>
                                :
                                <>
                                    {certNumberSendCheck ? 
                                        <>
                                            <div><b>{formatTime(secondsLeft)}</b></div>
                                        </>
                                        :
                                        <>
                                            <Button disabled={certNumberSendCheck} variant="contained" size="small" onClick={() => onSendEmailCode()}>
                                                인증번호 전송
                                            </Button>
                                        </>
                                    }
                                </>
                            }
                        </div>
                            
                        <div style={{height:"25px"}}></div>

                        <TextField 
                            disabled={!certNumberSendCheck || certNumberCertifiedCheck} 
                            fullWidth 
                            label="인증 코드 6자리를 입력해주세요." 
                            value={certNumber || ''}
                            onChange={(e) => setCertNumber(e.target.value)}/>

                        <div style={{height:"5px"}}></div>
                        
                        <div style={{
                            display:'flex',
                            justifyContent:'end',
                        }}>
                            {certNumberCertifiedCheck ? 
                            <>
                                <DoneIcon color="success"/>
                            </>
                            :
                            <>
                                <Button disabled={!certNumberSendCheck} variant="contained" size="small" onClick={() => onCheckCertNumber()}>
                                    확인
                                </Button>
                            </>}
                        </div>
                    </DialogContentText>
                </DialogContent>
               </> 
               
            }

           
           
        </Dialog>
    );
}
export default ResetPasswordDialog;